import { ColumnsConfig, ExtraFilterConfig } from '@mss/mss-component-library';
import type { TFunction } from 'i18next';

export function getFilterKeysFromColumns<AssetType = any>(
  columns: ColumnsConfig<AssetType>[],
  extraFilterKeys?: ExtraFilterConfig<AssetType>[]
) {
  return columns
    .reduce<{ key: string; order: number }[]>(
      (acc, col) =>
        col.filterable ? [...acc, { key: col.key, order: 2 }] : acc,
      (extraFilterKeys ?? []).map(({ key, top }) => ({
        key,
        order: top ? 1 : 3,
      }))
    )
    .sort((a, b) => a.order - b.order)
    .map(({ key }) => key) as (keyof AssetType)[];
}

export function getSearchKeysFromColumns<AssetType = any>(
  columns: ColumnsConfig<AssetType>[],
  extraSearchKeys?: string[]
) {
  return [
    ...columns.filter(col => col.searchable).map(col => col.key),
    ...(extraSearchKeys ?? []),
  ] as (keyof AssetType)[];
}

export function createCustomHeadingLabel<AssetType>(
  columns: ColumnsConfig<AssetType>[],
  t: TFunction,
  extraFilterKeys?: ExtraFilterConfig<AssetType>[]
) {
  return (key: keyof AssetType) =>
    extraFilterKeys?.find(x => x.key === key)?.customHeading?.(t) ??
    columns.find(x => x.key === key)?.customFilterHeading ??
    (key as string);
}

export function createCustomOptionLabels<AssetType>(
  columns: ColumnsConfig<AssetType>[],
  extraFilterKeys?: ExtraFilterConfig<AssetType>[]
) {
  return (key: keyof AssetType, value: AssetType[keyof AssetType]) => {
    const parser =
      extraFilterKeys?.find(x => x.key === key)?.customOption ??
      columns.find(x => x.key === key)?.customFilterOptions;
    return parser ? parser(value) : value;
  };
}
